/** Register SDF icons used by gl-draw scale symbol layers. */
export function ensureDrawTransformIcons(map: {
  hasImage?: (id: string) => boolean;
  addImage?: (id: string, image: ImageData, options?: { sdf?: boolean; pixelRatio?: number }) => void;
}) {
  if (!map?.addImage || !map?.hasImage) return;

  if (!map.hasImage('scale')) {
    map.addImage('scale', createScaleSdfIcon(32), { sdf: true, pixelRatio: 2 });
  }
}

function createScaleSdfIcon(size: number): ImageData {
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    return new ImageData(size, size);
  }

  const pad = size * 0.22;
  const x0 = pad;
  const y0 = pad;
  const x1 = size - pad;
  const y1 = size - pad;

  ctx.clearRect(0, 0, size, size);
  ctx.strokeStyle = '#ffffff';
  ctx.fillStyle = '#ffffff';
  ctx.lineWidth = Math.max(2, size * 0.09);
  ctx.lineCap = 'round';

  ctx.strokeRect(x0, y0, x1 - x0, y1 - y0);

  const arrow = size * 0.14;
  ctx.beginPath();
  ctx.moveTo(x1, y0);
  ctx.lineTo(x1 - arrow, y0);
  ctx.moveTo(x1, y0);
  ctx.lineTo(x1, y0 + arrow);
  ctx.stroke();

  ctx.beginPath();
  ctx.moveTo(x0, y1);
  ctx.lineTo(x0 + arrow, y1);
  ctx.moveTo(x0, y1);
  ctx.lineTo(x0, y1 - arrow);
  ctx.stroke();

  return ctx.getImageData(0, 0, size, size);
}
